// Source of truth for the in-page "jump to section" navigation dropdowns.
// Keyed by route path. Each entry: { id (anchor id on the page), label (menu text) }.
// Clicking a parent nav item goes to the page top; clicking a sub-item smooth-scrolls
// to the matching `id` (sections carry `scroll-mt-24` to offset the sticky header).
export const PAGE_SECTION_NAV = {
  "/": [
    { id: "home-paths", label: "Find Your Path" },
    { id: "home-app", label: "Trilogy App" },
    { id: "home-locations", label: "Locations" },
    { id: "home-cta", label: "Book Intro" },
  ],
  "/about": [
    { id: "about-mission", label: "Mission / Vision" },
    { id: "about-philosophy", label: "Philosophy" },
    { id: "about-serve", label: "Who We Serve" },
    { id: "about-experience", label: "Experience You Trust" },
    { id: "about-community", label: "Youth Development & Community" },
    { id: "about-facilities", label: "Facilities" },
    { id: "about-coaches", label: "Coaches" },
  ],
  "/locations": [
    { id: "locations-choose", label: "Choose Your Gym" },
    { id: "locations-details", label: "Location Details" },
    { id: "locations-directions", label: "Directions" },
  ],
  "/services": [
    { id: "services-programs", label: "Programs For You" },
    { id: "services-start", label: "Not Sure Where To Start" },
  ],
  "/packages": [
    { id: "packages-compare", label: "Compare Packages" },
    { id: "packages-client", label: "Already A Client" },
  ],
  "/booking": [
    { id: "booking-start", label: "Getting Started" },
    { id: "booking-options", label: "Booking Options" },
    { id: "booking-scheduler", label: "Book Online Now" },
  ],
  "/mavs-volleyball": [
    { id: "mavs-overview", label: "Training Overview" },
    { id: "mavs-steps", label: "Get Started In 6 Steps" },
    { id: "mavs-app", label: "Get The Trilogy App" },
    { id: "mavs-schedule", label: "Schedule" },
    { id: "mavs-packages", label: "Packages & Camps" },
    { id: "mavs-highlights", label: "Athlete Highlights" },
    { id: "mavs-parents", label: "Questions For Parents" },
  ],
  "/offers": [
    { id: "offers-active", label: "Active Promotions" },
    { id: "offers-cta", label: "Free Intro Workout" },
  ],
  "/events": [
    { id: "events-find", label: "Find Your Next Event" },
    { id: "events-cta", label: "Talk To Our Team" },
  ],
  "/testimonials": [
    { id: "testimonials-list", label: "Highlight Athletes" },
    { id: "testimonials-cta", label: "Start Your Story" },
  ],
  "/faq": [
    { id: "faq-list", label: "All Questions" },
    { id: "faq-cta", label: "Still Need Help" },
  ],
  "/support": [
    { id: "support-form", label: "Submit A Ticket" },
  ],
  "/contact": [
    { id: "contact-app", label: "Download The App" },
    { id: "contact-form", label: "Send A Message" },
    { id: "contact-info", label: "Reach Us" },
  ],
};

export const getPageSections = (path) => PAGE_SECTION_NAV[path] || [];
